import React from 'react';
import { connect } from 'react-redux';
import { OnboardingNavbar } from '../OnboardingNavbar/OnboardingNavbar';
import { OnboardingProgress } from '../OnboardingProgress/OnboardingProgress';
import { updateConfigOnboardingSettings, updateConfig } from '../../../redux/config/slice';
import { selectUpdateConfigLoading, selectConfig } from '../../../redux/config/selectors';
import { OnboardingActions } from '../OnboardingActions/OnboardingActions';
import {
  OnboardingContent,
  OnboardingHeaderGroup,
  OnboardingContentTitle,
  OnboardingStepWrapper,
  OnboardingContentGroupText,
  OnboardingContentInfo
} from '../../ui/Layout/OnboardingLayout';
import { ONBOARDING_STEPS } from '../../../consts/consts';
import { Heading2 } from '../../ui/Typography/Heading';

export const OnboardingStepHousingStockSuccessComponent = ({ updateConfigOnboardingSettings, updateConfigLoading }) => {
  const handleBack = () => {
    updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.PARTNER_USERS });
  };

  const handleOpenPortal = () => {
    updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.COMPLETED });
  };

  return (
    <>
      <OnboardingNavbar loading={updateConfigLoading} />
      <OnboardingProgress />
      <OnboardingContent>
        <OnboardingStepWrapper>
          <OnboardingHeaderGroup className="step-housing-stock-success">
            <OnboardingContentTitle>
              <Heading2>Der Bestand wurde erfolgreich angelegt</Heading2>
            </OnboardingContentTitle>
            <OnboardingContentInfo>
              <OnboardingContentGroupText>
                Die Einrichtung Ihres Bestands wurde erfolgreich abgeschlossen. Sie können nun mit der Nutzung des
                Portals beginnen und Ihre Arbeitsprozesse effizient verwalten.
              </OnboardingContentGroupText>
              <OnboardingContentGroupText>
                Alle soeben festgelegten Einstellungen können Sie jederzeit in der Verwaltung einsehen und bei Bedarf
                anpassen. Zusätzlich können sie beliebig viel weitere Bestände anlegen.
              </OnboardingContentGroupText>
            </OnboardingContentInfo>
          </OnboardingHeaderGroup>
        </OnboardingStepWrapper>
        <OnboardingActions
          onBack={handleBack}
          onNext={handleOpenPortal}
          nextIcon={false}
          loading={updateConfigLoading}
          nextLabel="Portal öffnen"
        />
      </OnboardingContent>
    </>
  );
};

const mapStateToProps = (state) => ({
  config: selectConfig(state),
  updateConfigLoading: selectUpdateConfigLoading(state)
});

const mapDispatchToProps = {
  updateConfigOnboardingSettings,
  updateConfig
};

export const OnboardingStepHousingStockSuccess = connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardingStepHousingStockSuccessComponent);
